import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min"; // Bootstrap JS
import banner1 from "../assets/images/banner1.jpeg";
import banner2 from "../assets/images/banner2.jpeg";
import banner3 from "../assets/images/banner4.jpg";
import banner4 from "../assets/images/banner.jpg";

const Banner = () => {
  useEffect(() => {
    // Ensure Bootstrap carousel starts automatically
    const carousel = document.querySelector("#consultingCarousel");
    if (carousel) {
      new window.bootstrap.Carousel(carousel, {
        interval: 1000, // Auto-slide every 1 second
        pause: false, // Don't pause on hover
        ride: "carousel",
      });
    }
  }, []);

  return (
    <div>
      {/* Style tag inside JSX */}
      <style>
        {`
          .carousel-item {
            height: 90vh;
            background-size: cover;
            background-position: center;
          }

          .carousel-caption {
            position: absolute;
            top: 60%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            text-align: center;
            width: 80%;
          }

          .carousel-caption h2 {
            font-size: 3rem;
          }

          .carousel-caption p {
            font-size: 1.25rem;
            color: #48c7ec;
            font-weight: bold;
          }

          /* Mobile Responsive Styling */
          @media (max-width: 768px) {
            .carousel-item {
              height: 60vh; /* Reduce height for mobile screens */
            }

            .carousel-caption {
              width: 90%;
              padding: 10px;
            }

            .carousel-caption h2 {
              font-size: 1.8rem; /* Smaller font size for mobile */
            }

            .carousel-caption p {
              font-size: 1rem; /* Adjust paragraph font size */
            }
          }

          @media (max-width: 480px) {
            .carousel-item {
              height: 50vh;
            }

            .carousel-caption h2 {
              font-size: 1.5rem;
            }

            .carousel-caption p {
              font-size: 0.9rem;
            }
          }
        `}
      </style>

      <div id="consultingCarousel" className="carousel slide" data-bs-ride="carousel">
        {/* Carousel Inner */}
        <div className="carousel-inner">
          <div className="carousel-item active" style={{ backgroundImage: `url(${banner1})` }}>
            <div className="carousel-caption">
              <h2>IT Strategy Consulting</h2>
              <p>Develop a clear IT roadmap that aligns with your business objectives.</p>
            </div>
          </div>

          <div className="carousel-item" style={{ backgroundImage: `url(${banner2})` }}>
            <div className="carousel-caption">
              <h2>Technical Support & Troubleshooting</h2>
              <p>Our dedicated technical support team identifies and resolves software issues, ensuring minimal disruption to your operations.</p>
            </div>
          </div>

          <div className="carousel-item" style={{ backgroundImage: `url(${banner3})` }}>
            <div className="carousel-caption">
              <h2>Training & Skill Development</h2>
              <p>Empower your team by providing training that enhances their existing skills and introduces new ones.</p>
            </div>
          </div>

          <div className="carousel-item" style={{ backgroundImage: `url(${banner4})` }}>
            <div className="carousel-caption">
              <h2>Talent Acquisition & Staffing</h2>
              <p>We help businesses find the right talent for open positions by providing carefully selected profiles that match specific job requirements.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
